import { Session, SupabaseClient } from "@supabase/supabase-js";
import { useQuery } from "react-query";
import { getSupaClient } from "../../lib/supabase";

const supabase = getSupaClient();

// Hook related to guilds
function useGuilds() {
  const getDotsBotExists = async function (
    guildId: string,
    session: Session | null
  ) {
    // This function runs after signing in and sometimes session is null
    // for that reason we need to check if session exists
    if (guildId && session) {
      const response = await fetch(
        `${process.env["REACT_APP_API_URL"]}/guilds/${guildId}/dots-bot-exists`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${session?.access_token}` },
        }
      );

      if (response.ok) {
        return response.json();
      }
      const errorResponse = JSON.stringify(await response.json());
      throw new Error(`Error getting Dots bot status ${errorResponse}`);
    }
  };

  const dotsBotsExistsQuery = function (guildId: string) {
    const supabase = getSupaClient();
    const session = supabase.auth.session();
    return useQuery<{ botExists: boolean }>(
      ["guild", guildId, session],
      () => getDotsBotExists(guildId, session),
      {
        retry: false,
      }
    );
  };

  return {
    dotsBotsExistsQuery,
  };
}

export default useGuilds;
